import { Asset } from '@dtu/types';

export interface InternalFile extends Asset {}
